import { Button, message, Modal, Space } from 'antd';
import React from 'react';
import { useConfirmPCodeUploadMutation } from 'services/pcodes/pcodes-api';
import { PCodeDelta } from 'services/pcodes/types';
import styled from 'styled-components';
import labels from 'ui/labels.json';
import PCodesDeltaTable from './pcodes-delta-table';

const {
  pcodes: { lbl_confirmText, lbl_PCodeTransferComplete },
  common: { lbl_cancel },
} = labels;

const ConfirmButtons = styled.div`
  margin-top: 24px;
  float: right;
`;

export interface IPCodesDeltaConfirmationModal {
  deltaData: Array<PCodeDelta>;
  fileKey: string;
  version: number;
}

const PCodesDeltaConfirmationModal = ({
  deltaData,
  fileKey,
  version,
}: IPCodesDeltaConfirmationModal) => {
  const [confirmPCode, { isLoading }] = useConfirmPCodeUploadMutation();
  return (
    <>
      <PCodesDeltaTable deltaData={deltaData} />
      <ConfirmButtons>
        <Space>
          <Button
            disabled={isLoading}
            onClick={() => {
              Modal.destroyAll();
            }}
          >
            {lbl_cancel}
          </Button>
          <Button
            type="primary"
            loading={isLoading}
            onClick={async () => {
              const result = await confirmPCode({ fileKey, version }).unwrap();
              if ('error' in result) {
                message.error('An error occurred');
              } else {
                Modal.destroyAll();
                message.success(lbl_PCodeTransferComplete);
              }
            }}
          >
            {lbl_confirmText}
          </Button>
        </Space>
      </ConfirmButtons>
    </>
  );
};

export default PCodesDeltaConfirmationModal;
